<mat-icon class="file-icon" [svgIcon]="icon"></mat-icon>

<div
	(click)="open()"
	[class.file-has-errors]="hasError()"
	class="file-name file-clickable"
>
	{{ name || fileData.name }}
</div>
